import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'organization' })
export class OrganizationPipe implements PipeTransform {
  transform(
    value: any,
    allName: boolean = true,
  ): string {
    if (!value || Array.isArray(value) && value.length === 0) {
      return '';
    } else if (Array.isArray(value) && value.length) {
      return value
        .map((org) => this.getOrgName(org, allName))
        .join(', ');
    } else if (typeof value === 'object') {
      return this.getOrgName(value, allName);
    } else {
      return value;
    }
  }

  getOrgName(org, allName?) {
    if (allName) {
      return org.levelName ? org.levelName : (org.full_name ? org.full_name : org.fullName);
    } else {
      return (org.code ? `[${org.code}] ` : '') + (org.full_name ? org.full_name : org.fullName);
    }
  }
}
